<template>
  <h1>News</h1>
</template>
